import { useDispatch } from 'react-redux';
import { AvailableErrors, ContextInputDto, ContextOutputDto, ContextTypeRequest } from '@api/izibizi-xp';
import { useAutoFetch } from '@hooks';
import { getSessionStorage, saveSessionStorage } from '@helpers';
import { saveErrorServiceResponse, saveSuccessServiceResponse, saveUserInput, saveTempData } from '@store';
import { modals } from '@modals';
import { useShowHide } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { useNavigation } from '@navigation';
import { Anything } from '@types';

export const useFetchRetrieveContext = () => {
	const dispatch = useDispatch();
	const contextId = getSessionStorage<string>('contextId');
	const ott = getSessionStorage<string>('ott');
	const tokenOAuth = getSessionStorage<string>('tokenOAuth');
	const state = getSessionStorage<string>('state');
	const { navigate } = useNavigation();
	const { show } = useShowHide(modals.errorCaeOrAml);

	return useAutoFetch<ContextInputDto, ContextOutputDto>({
		data: {
			token: contextId || ott || tokenOAuth || '',
			type: contextId ? ContextTypeRequest.RECOVER : ott ? ContextTypeRequest.OTT : ContextTypeRequest.TOKEN,
			signature: state,
		},
		operationKey: 'retrieveContext',
		cache: {
			key: 'retrieveContext',
		},
		onSuccess: (res) => {
			if (res.data) {
				saveSessionStorage('contextId', res.data.customerInformation?.sessionId || '');
				dispatch(saveSuccessServiceResponse({ retrieveContext: res.data }));
				dispatch(
					saveUserInput({
						email: res.data?.customerInformation?.email,
						hasIntegratedSolution: res.data?.customerInformation?.integratedSolution,
					})
				);
			}
		},
		onError: (response) => {
			dispatch(saveErrorServiceResponse({ errors: response.errors, type: response.type }));
			if (
				response.errors.filter(
					(err: Anything) =>
						//ADD NEW ERROR FOR INVALID USER US 769060
						err.code === AvailableErrors.IziBiziRiskAML || err.code === AvailableErrors.IziBiziInvalidCAE
				).length > 0
			) {
				show();
			} else if (
				response.errors.filter((err: Anything) => err.code === AvailableErrors.IziBiziUnauthorized).length > 0
			) {
				dispatch(saveTempData({ isUnauthorizedUser: true }));
			} else {
				navigate('serviceError');
			}
		},
	});
};
